import React, { useEffect, useState } from "react";
import { Card, Grid } from "@mui/material";
import "../../styles/available-points/available-points.scss";
import "../../styles/main.scss";
import { CircularProgress } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";
import "../../styles/request-otp/request-otp.scss";
import axios from "axios";
import AvailablePointsMobileView from "./available-points-mobile-view";
const AvailblePoints = ({ receiveCouponPoints, loyaltyInfo, loyaltyData, isCouponcodeDisabled, couponCode, woocommerceCoupons, isWcoupon }) => {
  const [couponPoints, setCouponPoints] = useState("");
  const [isCouponpointsDisable, setIsCouponpointsDisabled] = useState(false);
  const [woocommerceCoupon, setWoocommerceCoupon] = useState("");
  const [woocommerceCouponError, setWoocommerceCouponError] = useState("");
  const [copied, setCopied] = useState(false);
  const [isLoder, setIsLoader] = useState(false);
  const [cartValue, setCartValue] = useState("");
  const [store, setStore] = useState("");

  // const hasInitialTime = localStorage.getItem("initialTime") !== null;

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setCartValue(searchParams.get("cart"));
    setStore(searchParams.get("storeUrl"));
  }, []);

  const handleCoupons = (event) => {
    setCouponPoints(event.target.value);
  };

  const handleSubmitCouponPoints = async (event) => {
    event.preventDefault();
    setIsLoader(true);
    const requestData = {
      mobile_number: loyaltyInfo.details.mobile || null,
      country_code: loyaltyData?.countryCode,
      points: couponPoints,
      bill_amount: cartValue,
      store_url: store,
      minimum_bill: loyaltyInfo?.minimum_bill.toString(),
    };

    await axios
      .post(`${process.env.REACT_APP_PRODUCTION_URL}/api/ewards/redeem-points`, requestData)
      .then((response) => {
        setWoocommerceCoupon(response?.data?.woocommerce_coupon);
        setWoocommerceCouponError("");
        // if (hasInitialTime) {
        //   localStorage.setItem("pointsCoupon", response?.data?.woocommerce_coupon);
        // }
        setIsLoader(false);
        setIsCouponpointsDisabled(true);
        receiveCouponPoints(true);
        woocommerceCoupons(true);
      })
      .catch((error) => {
        setIsLoader(false);
        setWoocommerceCouponError(error?.response?.data?.resultMessage?.en);
        setIsCouponpointsDisabled(false);
      });
  };

  const handleCopyClick = () => {
    const input = document.createElement("input");
    input.style.position = "fixed";
    input.style.opacity = 0;
    input.value = woocommerceCoupon;
    document.body.appendChild(input);

    input.select();
    input.setSelectionRange(0, 99999); // For mobile devices

    document.execCommand("copy");

    document.body.removeChild(input);

    setCopied(true);
    setTimeout(() => setCopied(false), 4000); // Reset 'copied' state after 4 seconds
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card className="container1 " sx={{ background: "#F7F7F8" }}>
          <div style={{ marginTop: "-42px" }}>
            <p style={{ fontWeight: 500, fontSize: "15px" }}>Redeem your loyalty points here</p>
            {/* <h5 style={{ fontWeight: 100, marginTop: '-10px', fontSize: '15px' }}>
    (value of each point is 
    <span style={{color:  "var(--primary-color)", fontWeight: 500, verticalAlign: 'middle' ,marginLeft:'10px'}}>
      <MdCurrencyRupee /> 
    </span> <span  style={{ fontWeight: 500, marginTop: '-10px', fontSize: '15px',color:  "var(--primary-color)", }}>10</span>   )
  </h5> */}
          </div>

          {/* <div className='points-container'> */}
          <Card sx={{ width: "auto", borderRadius: 1, height: "auto", padding: 2 }} className="container2">
            <div className="available-balance-container">
              <div>
                <p className="availblepointsmarging">Available Balance:</p>
                {/* <p className="availblepointsmarging">Redeemable Balance:</p> */}
              </div>
              <div>
                <p className="availblepointsmarging">{loyaltyInfo?.points_available}</p>
                {/* <p className="availblepointsmarging">80</p> */}
              </div>
            </div>
          </Card>
          <form onSubmit={handleSubmitCouponPoints}>
            {/* <div className={`points-redem-container1 wc-block-components-text-input ${iscouponpoints ? 'has-error' : ''}`}> */}
            <div className="points-redem-container1">
              <input className="custom-textfield" id="coupon-points" label="Coupon Points" value={couponPoints} onChange={handleCoupons} disabled={isCouponcodeDisabled || couponCode || isCouponpointsDisable} />
              <button
                type="submit"
                disabled={isCouponpointsDisable || couponCode || isCouponpointsDisable || !couponPoints}
                className={isCouponpointsDisable || isCouponcodeDisabled || couponCode || !couponPoints ? "custom-button2 mobile-field" : "custom-button1 mobile-field"}
                // className='custom-button1'
              >
                Credit Redemption
              </button>
            </div>
          </form>
          {/* </div> */}
          {isLoder && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px", marginLeft: "50px" }}>
              <CircularProgress sx={{ color: "var(--primary-color)" }} />
            </div>
          )}
          {woocommerceCoupon && (
            <div className="custom-textfield2">
              <p>{woocommerceCoupon}</p>
              {!copied ? <FaRegCopy onClick={handleCopyClick} style={{ marginTop: "0px", marginLeft: "30px", cursor: "pointer" }} /> : <p style={{ marginTop: "15px", marginLeft: "30px", color: "green" }}>Copied!</p>}
            </div>
          )}

          {woocommerceCouponError && <p className="error-msg">{woocommerceCouponError}</p>}
        </Card>
        <AvailablePointsMobileView
          loyaltyInfo={loyaltyInfo}
          isCouponcodeDisabled={isCouponcodeDisabled}
          couponCode={couponCode}
          handleSubmitCouponPoints={handleSubmitCouponPoints}
          handleCoupons={handleCoupons}
          couponPoints={couponPoints}
          isCouponpointsDisable={isCouponpointsDisable}
          copied={copied}
          handleCopyClick={handleCopyClick}
          woocommerceCoupon={woocommerceCoupon}
          woocommerceCouponError={woocommerceCouponError}
          isLoder={isLoder}
          isWcoupon={isWcoupon}
        />
      </Grid>
    </Grid>
  );
};

export default AvailblePoints;
